<img
    alt="image"
    *ngIf="
        showIfNotLoaded || imageSrc !== '/assets/images/logo/generic_img.webp'
    "
    [class]="imageClass"
    [ngSrc]="imageSrc"
    (error)="imageSrc = '/assets/images/logo/generic_img.webp'"
    height="100"
    width="100  "
/>
